import { render, staticRenderFns } from "./categories-allocation-area.vue?vue&type=template&id=6d2c9eac&scoped=true"
import script from "./categories-allocation-area.vue?vue&type=script&lang=js"
export * from "./categories-allocation-area.vue?vue&type=script&lang=js"
import style0 from "./categories-allocation-area.vue?vue&type=style&index=0&id=6d2c9eac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2c9eac",
  null
  
)

export default component.exports